
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[sort_url]",
      function () {
        return require("private-next-pages/project/[sort_url].js");
      }
    ]);
  